/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Paper from '@material-ui/core/Paper';
import React, { useState } from "react";
import { Badge, Button, Card, CardHeader, Col, Container, Row, Spinner } from "reactstrap";
import AdminUserModal from '../components/AdminUserModal';
import AdminUserScreenHeader from "../components/Headers/AdminUserScreenHeader";
import UserManagementTable from '../components/UserManagementTable';
import { useAdminAllUsers } from '../hooks/useAdminAllUsers';

const resultsPerPage = 10;

const AdminUsers: React.FC = () => {
  const [pageTable, setPageTable] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')
  const [finalSearchTerm, setFinalSearchTerm] = useState('')
  const [modalOpen, setModalOpen] = useState(false)

  const handleSearch = () => {
    if (isLoading && searchTerm.length > 0) {
      return;
    }

    setPageTable(1)
    setFinalSearchTerm(searchTerm)
  }

  const { data: userData, isLoading, error } = useAdminAllUsers(pageTable, resultsPerPage, finalSearchTerm)

  let content: JSX.Element | null = null

  if (isLoading) {
    content = <Spinner />
  } else if (error) {
    content = <Badge type="danger" className="text-center">Something went wrong! Please try again later.</Badge>
  } else if (userData) {
    content = <div>
      <UserManagementTable currentPage={pageTable} onPageChange={setPageTable} resultsPerPage={resultsPerPage} userData={userData.data} total={userData.total} />
    </div>
  }

  return (
    <>
      <AdminUserScreenHeader />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col>
                    <h2>Users</h2>
                  </Col>
                  <Col>
                    <Button style={{ float: "right" }} size="sm" color="warning" onClick={() => setModalOpen(true)}>
                      Add User
                    </Button>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <div className="col">
                    <div className="input-group-alternative input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text text-warning">
                          <i className="fas fa-search" onClick={handleSearch}></i>
                        </span>
                      </div>
                      <input placeholder="Search user by name"
                        type="text"
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSearch()
                          }
                        }} />
                    </div>
                  </div>
                </Row>
              </CardHeader>
              <Paper className="overflow-auto px-4 pb-4">
                {/* <div className="mb-3">
                  <h4 style={{ display: 'inline' }}>Search Results</h4>
                </div> */}
                {content}
              </Paper>
            </Card>
          </Col>
        </Row>
      </Container>
      <AdminUserModal type='Create' open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default AdminUsers;
